var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttorney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.149,
    height: 102.901,
    viewBox: "0 0 144.149 102.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 1.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M0,96.912H6.755v-4.5A8.977,8.977,0,0,1,9.4,86.047h.012A8.994,8.994,0,0,1,15.767,83.4H63.059a9.03,9.03,0,0,1,9.008,9.008v4.5h6.755v4.506H0V96.912Zm53.582-86.2L74.32,24.265l3.7-5.661.106-.163a4.516,4.516,0,0,0-1.412-6.065l-.208-.135-.008-.008L63.512,3.752a4.511,4.511,0,0,0-6.232,1.31l-3.694,5.657ZM71.859,28.028,51.117,14.478,36.33,37.114,57.072,50.66ZM54.619,54.419,33.877,40.869l-3.7,5.661,0,0a4.528,4.528,0,0,0,1.306,6.237h.008l13.2,8.624,0,0a4.52,4.52,0,0,0,6.237-1.314l3.7-5.661ZM26.411,44.069l27.1-41.48A9.027,9.027,0,0,1,65.969-.024L79.169,8.6l.2.135.012.012a9.015,9.015,0,0,1,2.4,12.3l0,.008,0,0L72.035,35.979l65.823,35.187.155.09.02.008a12.53,12.53,0,0,1,5.837,13.461,14.873,14.873,0,0,1-5.943,9.1,12.533,12.533,0,0,1-14.665.057l-.118-.073-.049-.041L64.427,47.628,54.684,62.542a9.025,9.025,0,0,1-12.457,2.612h-.008L29.02,56.53l0,0a9.016,9.016,0,0,1-2.616-12.453v-.008ZM69.573,39.75l-2.677,4.1,58.921,46.337a8.226,8.226,0,0,0,9.526-.037,10.492,10.492,0,0,0,4.13-6.322,8.219,8.219,0,0,0-3.886-8.783L69.573,39.755ZM11.257,96.908h56.3v-4.5A4.529,4.529,0,0,0,63.047,87.9H15.755a4.513,4.513,0,0,0-3.184,1.318l0,0a4.5,4.5,0,0,0-1.326,3.18v4.5Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttorney);
export default __webpack_public_path__ + "static/media/Attorney.6de47318a7ac6ae53ada509a9d11657e.svg";
export { ForwardRef as ReactComponent };